import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { addSubscriptionTopUp, deleteSubscriptionTopUp, fetchSubscriptionTopUp, updateSubscriptionTopUp } from "./SubscriptionTopUpAPI";


const initialState = {
  data: [],
  loading: false,
  pagination: {
    current_page: 1,
    last_page: 1,
    total: 0,
  },
  error: null,
};

export const fetchSubscriptionTopUpAsync = createAsyncThunk(
  "subscriptionTopUp/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchSubscriptionTopUp();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addSubscriptionTopUpAsync = createAsyncThunk(
  "subscriptionTopUp/add",
  async (newSubscription, { rejectWithValue }) => {
    try {
      const response = await addSubscriptionTopUp(newSubscription);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateSubscriptionTopUpAsync = createAsyncThunk(
  "subscription/update",
  async ({ id, updateSubscriptiondata }, { rejectWithValue }) => {
    try {
      const response = await updateSubscriptionTopUp(id, updateSubscriptiondata);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteSubscriptionTopUpAsync = createAsyncThunk(
  "subscriptionTopUp/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteSubscriptionTopUp(id);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const subscriptionTopUpSlice = createSlice({
  name: "subscriptionTopUp",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch cases
      .addCase(fetchSubscriptionTopUpAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubscriptionTopUpAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchSubscriptionTopUpAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Add cases
      .addCase(addSubscriptionTopUpAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addSubscriptionTopUpAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = [...state.data, action.payload];
        state.error = null;
      })
      .addCase(addSubscriptionTopUpAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update cases
      .addCase(updateSubscriptionTopUpAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSubscriptionTopUpAsync.fulfilled, (state, action) => {
        state.loading = false;
        const updatedPlan = action.payload;
        state.data = state.data.map((plan) =>
          plan.uuid === updatedPlan.uuid ? updatedPlan : plan
        );
        state.error = null;
      })
      .addCase(updateSubscriptionTopUpAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Delete cases
      .addCase(deleteSubscriptionTopUpAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteSubscriptionTopUpAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.data = state.data.filter(
          (item) => item.uuid !== action.payload.id
        );
        state.error = null;
      })
      .addCase(deleteSubscriptionTopUpAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const selectSubscriptionTopUp = (state) => state.subscriptionTopUp.data;
// export const selectSubscriptionLoading = (state) => state.subscription.loading;
// export const selectSubscriptionError = (state) => state.subscription.error;
// export const selectPagination = (state) => state.subscription.pagination;

export default subscriptionTopUpSlice.reducer;
